<template>
    <div class="free-trial-container h-100 w-100 d-flex align-items-center justify-content-center gap-16">
        
        <template v-if="!openCardDetails">
            <div class="free-trial-icon">
                <img src="@/assets/calendar-time.svg" width="250px" height="250px" class="object-fit-contains" alt="">
            </div>

            <div class="free-trial-content d-flex flex-column gap-16">
                <template v-if="!isExpired">
                    <h1>
                        Your free trial will end soon!
                    </h1>

                    <span class="d-block"> 
                                                                                                                                                                                                                                                             
                        Hi <span class="venue_name font-weight-bold">{{ venueName }}</span>, {{ `your trial will end in ${info.remainingDays} ${info.remainingDays == 1 ? `day.` : `days.`}` }}
                    </span>
                </template>

                <template v-if="isExpired">
                    <h1>
                        Free Trial has <span>EXPIRED!</span>
                    </h1>

                    <span class="d-block">
                        Hi <span class="venue_name font-weight-bold">{{ venueName }}</span>, your free trial has expired. Activate below to continue to use Peiso.
                        
                    </span>

                    <span class="small d-block m-top-10">
                        If you have any questions, please contact us at <a href="#" class="small support font-weight-bold">getpeiso@peiso.com.au</a>.
                    </span>
                </template>

                <div class="d-flex gap-10 justify-content-center m-top-1rem">
                    <el-button @click="openCard" type="peiso-primary-pink-border-only">Activate your Subscription Here</el-button>
                    <el-button type="peiso-white-border-only" @click="closeNotice">{{ isExpired ? 'Logout' : 'Continue' }}</el-button>
                </div>
            </div>
        </template>

        <template v-else>
            <div v-if="sub" class="free-trial-subscripion px-10" >
                <card-subscription :info="sub"></card-subscription>
            </div>

            <div class="free-trial-content d-flex flex-column gap-32 px-10">
                <h3>Payment Method</h3>

                <div class="d-flex flex-column gap-16">
                    <div class="field">
                        <span>Card number</span>
                        <el-input type="number" v-model="card.cardNumber" class="peiso-input-default-alata" pattern="/^-?\d+\.?\d*$/" onKeyPress="if(this.value.length==16) return false;"></el-input>
                    </div>
                    
                    <div class="field">
                        <span>Card name</span>
                        <el-input v-model="card.cardName" class="peiso-input-default-alata"></el-input>
                    </div>
                    
                    <div class="d-flex gap-16">
                        <div class="field w-100">
                            <span>Expiry Date (MMYY)</span>
                            <div class="d-flex justify-content-between align-items-center">
                                <el-input type="number" v-model="card.expireMonth" class="text-center peiso-input-default-alata" placeholder="MM" pattern="/^-?\d+\.?\d*$/" onKeyPress="if(this.value.length==2) return false;"></el-input>
                                <el-input type="number" v-model="card.expireYear" class="text-center peiso-input-default-alata" placeholder="YY" pattern="/^-?\d+\.?\d*$/" onKeyPress="if(this.value.length==2) return false;"></el-input>
                            </div>
                        </div>
                        <div class="field w-100">
                            <span>CVV</span>
                            <el-input type="number" v-model="card.cvv" class="peiso-input-default-alata text-center" pattern="/^-?\d+\.?\d*$/" onKeyPress="if(this.value.length==4) return false;"></el-input>
                        </div>
                    </div>
                    
                    <div class="d-flex gap-10 justify-content-center m-top-1rem">
                        <el-button @click="saveCard" type="peiso-primary-pink-border-only">Activate your Subscription Here</el-button>
                        <el-button type="peiso-white-border-only" @click="closeNotice">{{ isExpired ? 'Logout' : 'Continue' }}</el-button>
                    </div>
                </div>

                
            </div>
        </template>

    </div>
</template>

<style lang="scss" scoped>
@import 'static/scss/fonts/fonts.scss';
@import "static/scss/scrollbar.scss";
    .free-trial-container {
        .free-trial-content {
            width: 412px;
            .field {
                span {
                    @include alata-fonts(14px, normal, 400, $white) {
                        margin-bottom: 7px;
                        text-align: left;
                        display: block;
                    }
                }


            }
            h1 {
                @include montserrat-font(40px, normal, 800, var(--primary-color)) {
                    text-align: center;
                }

                > span {
                    @include montserrat-font(40px, normal, 900, var(--primary-color));
                }
            }

            h3 {
                @include montserrat-font(24px, normal, 700, var(--primary-color)) {
                    text-align: center;
                }
            }

            span {
                @include montserrat-font(16px, normal, 400, $white) {
                    text-align: center;
                    word-break: normal;
                }

                &.small {
                    font-size: 12px !important;
                }

                .support {
                    text-decoration: underline;
                    color: var(--text-color);
                }
            }


        }

        .free-trial-subscripion {
            .subscription-details-container {
                width: 350px;
            }
        }

        .el-button {
            &--peiso-primary-pink-border-only {
                @include alata-fonts(16px, normal, 400, var(--primary-color)) {
                    padding: 1rem;
                    margin: 0px !important;
                }
            }   

            &--peiso-white-border-only {
                @include alata-fonts(16px, normal, 400, $white) {
                    padding: 1rem;
                    margin: 0px !important;
                }

            }
        }

        .venue_name {
            letter-spacing: 0.4px;
            // color: var(--primary-color) !important;
        }


    }
    
</style>

<script>
import cardSubscription from '@/components/card/subscription.vue';
import api from '@/api/api';
import utils from '../../utils/utils';
export default {
    data() {
        return {
            openCardDetails: false,
            card: {
                cardNumber: null,
                cardName: null,
                cvv: null,
                expireMonth: null,
                expireYear: null,
            },
            sub: null,
            venueName: sessionStorage.getItem('subVenueName')
        }
    },

    components: {
        cardSubscription: cardSubscription
    },

    computed: {
        isExpired() {
            return this.info && this.info.remainingDays <= 0 ? true : false
        }

    },

    watch: {
        info(val) { 
            if (val) {
                console.log(val, 'info')   
            }
        }
    },

    props: {
        info: {
            default: false,
        },

        isPro: {
            default: null
        }
    },

        methods: {
            saveCard() {
                var subscriptionDetails = this.getSubscription()
                this.card.cusToken = ''
                this.card.monthly_fee = subscriptionDetails.totalPaymentAmount
                this.card.expiry = `${this.card.expireMonth}${this.card.expireYear}`
                api.updateCard(this.card).then((res) => {
                    var data = res.data.data
                    if (res.data.code == 0) {
                        this.$emit('close-notice', 1)
                    } else {
                        utils.alert2('', res.data.message, 'error')
                    }
                })
            },

        getSubscription() { 
            var subscription = {}

            var price = 0, discount = 0
            if (this.isPro) {
                price = 250
            } else {
                price = 149
            }
            
            subscription.subscriptionPrice = price
            subscription.subscriptionDisplay = ''
            subscription.subscriptionDiscount = discount
            subscription.subscriptionGst = (price - discount) * 0.1
            subscription.totalPaymentAmount = (price - discount) * 1.1

            return subscription
        },

        closeNotice() {
            this.$emit('close-notice')
        },

        openCard() {
            this.sub = this.getSubscription()
            this.openCardDetails = true
        }

    }
}
</script>


// WEBPACK FOOTER //
// src/components/modal/freeTrialNotice.vue